export const SCRATCHCARD_PATHS = {
    DETAIL: {
        path: '/zreby/zreb/:slug',
        name: 'SCRATCHCARD_DETAIL'
    },
    KIOSK_LIST: {
        path: '/zreby/zoznam-predajcov',
        name: 'SCRATCHCARD_KIOSK_LIST'
    },
    FAQ: {
        path: '/zreby/faq',
        name: 'SCRATCHCARD_FAQ'
    },
    PARTNER_ZONE: {
        path: '/zreby/partnerska-zona',
        name: 'SCRATCHCARD_PARTNER_ZONE'
    },
    CONTACT: {
        path: '/zreby/kontakt',
        name: 'SCRATCHCARD_CONTACT'
    },
    I_SCRATCH: {
        path: '/zreby/co-su-i-zreby',
        name: 'SCRATCHCARD_I_SCRATCH'
    },
    I_SCRATCH_PLAY: {
        path: '/zreby/game/:gameId/:mode',
        name: 'SCRATCHCARD_I_SCRATCH_PLAY'
    },
    OVERVIEW: {
        path: '/zreby',
        name: 'SCRATCHCARD_OVERVIEW'
    },
    CASINO: {
        path: '/casino',
        name: 'CASINO_KASINO_LOBBY'
    }
} as const;
